import DOMPurify from 'dompurify'

/**
 * Sanitize user-authored rich text (e.g. tiptap `getHTML()` output stored on
 * the API) before it is rendered with `v-html`. Keeps safe markup, strips
 * scripts and inline event handlers (DOMPurify defaults).
 */
export function sanitizeHtml(source: string | null | undefined): string {
  if (!source) return ''
  return DOMPurify.sanitize(source)
}

/**
 * Clean HTML by removing empty paragraphs and trimming
 * Matches the logic from VisualTextEditor.cleanHtml
 * e.g: <p></p><div>test</div> → <div>test</div>
 */
export function cleanHtml(value: string | null | undefined): string {
  if (!value) return ''
  return value.replaceAll(/<p>\s*<\/p>/g, '').trim() // Remove empty paragraphs
}

/**
 * Extract plain text from HTML content
 * e.g: <p>test</p><div>example</div> → testexample
 */
export function getPlainText(html: string): string {
  return html.replace(/<[^>]*>/g, '').trim()
}
